module.exports = __webpack_public_path__ + "static/img/companybg1.a2a756c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companybg1.png
// module id = iYYA
// module chunks = 0